export enum AnalyzeCompareWith {
  Nothing = 'Nothing',
  NormalAdjusted = 'NormalAdjusted',
  SupplyTemp = 'SupplyTemp',
  ReturnTemp = 'ReturnTemp',
  OutdoorTemp = 'OutdoorTemp',
  Humidity = 'Humidity',
  Evmrt = '"Evmrt',
  AllTemps = 'AllTemps',
  Prognosis = 'Prognosis'
}
